module.exports = __webpack_public_path__ + "img/辅助决策.ebb5e147.png";